import { of, Observable } from "rxjs";

declare global {
  interface T {
    toObservable(): Observable<T>;
  }
}

Array.prototype.toObservable = function<T>(this: T): Observable<T> {
  return of(this);
}

export { }
